/* eslint-disable */
import { COMMON_ACTIVITY_DETAIL, GET_GROUPS_FAILED, GET_GROUPS_SUCCESS, GET_GROUPS_REQUEST, ADD_ACTIVTY_GROUP_ACTIVITTIES, DELETE_ACTIVITY_DETAILS, DELETE_ACTIVITY_GROUP, POST_ACTIVITY_DETAIL, POST_ACTIVITY_GROUP_DETAIL, RESET_ACTVITY_DETAILS_AND_ACTIVITY_GROUPS, UPDATE_ACTIVITY_GROUP_DETAIL_ACTIVITY_DETAILS, UPDATE_ACTIVTITY_DETAILS, DELETE_COMMON_DETAILS, FETCH_EXCERSIZE_DATA, DELETE_EXCERSIZE_DATA, FETCH_BLOCK_DATA, DELETE_BLOCK_DATA, FETCH_GROUP_DATA, DELETE_GROUP_DATA, FETCH_WEEK_GROUP_DATA, EDIT_WEEK_DATA, EDIT_EXCERSIZE_DATA, EDIT_GROUP_DATA, EDIT_BLOCK_DATA, EDIT_BLOCK_EXCERSIZE_DATA, EDIT_UPDATE_ACTIVITY_GROUP_DETAIL_ACTIVITY_DETAILS, DELETE_EDITED_COMMON_DETAILS, ADD_GROUP_DATA, ADD_BLOCK_DATA, WEEK_BLOCK_MODAL_DATA, WEEK_EDIT_BLOCK_DATA, WEEK_EDIT_EXCERCIZE, WEEK_EDIT_UPDATE_ACTIVITY_GROUP_DETAIL_ACTIVITY_DETAILS, DELETE_EDIT_WEEK_DATA, FETCH_EDIT_BLOCK_DATA, CLEAR_EDIT_BLOCK_EXCERSIZE_DATA, ADD_WEEK_DATA_SUCCESS, CREATE_EXERCISE_SUCCESS, CREATE_EXERCISE_FAILED, CREATE_EXERCISE_REQUEST, GET_LIST_EXERCISE_REQUEST, GET_LIST_EXERCISE_SUCCESS, GET_LIST_EXERCISE_FAILED, GET_EXERCISE_FAILED, GET_EXERCISE_REQUEST, GET_EXERCISE_SUCCESS, UPDATE_EXCERSIZE_DATA_REQUEST, UPDATE_EXCERSIZE_DATA_SUCCESS, UPDATE_EXCERSIZE_DATA_FAILED, DELETE_EXCERSIZE_DATA_SUCCESS, DELETE_EXCERSIZE_DATA_FAILED, GET_LIST_PROGRAM_EXERCISE_REQUEST, GET_LIST_PROGRAM_EXERCISE_SUCCESS, GET_LIST_PROGRAM_EXERCISE_FAILED, DELETE_EXCERSIZE_DATA_REQUEST, GET_PROGRAM_EXERCISE_REQUEST, GET_PROGRAM_EXERCISE_SUCCESS, GET_PROGRAM_EXERCISE_FAILED, CREATE_PROGRAM_EXERCISE_FAILED, CREATE_PROGRAM_EXERCISE_SUCCESS, CREATE_PROGRAM_EXERCISE_REQUEST, UPDATE_PROGRAM_EXERCISE_REQUEST, DELETE_PROGRAM_EXERCISE_FAILED, DELETE_PROGRAM_EXERCISE_SUCCESS, DELETE_PROGRAM_EXERCISE_REQUEST, GET_LIST_BLOCKS_SUCCESS, GET_LIST_BLOCKS_REQUEST, GET_LIST_BLOCKS_FAILED, CREATE_BLOCKS_REQUEST, CREATE_BLOCKS_SUCCESS, CREATE_BLOCKS_FAILED, DELETE_BLOCKS_REQUEST, DELETE_BLOCKS_SUCCESS, DELETE_BLOCKS_FAILED, UPDATE_BLOCKS_REQUEST, UPDATE_BLOCKS_SUCCESS, UPDATE_BLOCKS_FAILED, GET_BLOCK_REQUEST, GET_BLOCK_SUCCESS, GET_BLOCK_FAILED, GET_LIST_GROUPS_REQUEST, GET_LIST_GROUPS_SUCCESS, GET_LIST_GROUPS_FAILED, CREATE_GROUPS_REQUEST, CREATE_GROUPS_SUCCESS, CREATE_GROUPS_FAILED, UPDATE_GROUPS_REQUEST, UPDATE_GROUPS_SUCCESS, UPDATE_GROUPS_FAILED, DELETE_GROUPS_REQUEST, DELETE_GROUPS_SUCCESS, DELETE_GROUPS_FAILED, GET_LIST_PROGRAM_DAYS_REQUEST, GET_LIST_PROGRAM_DAYS_SUCCESS, GET_LIST_PROGRAM_DAYS_FAILED, GET_PROGRAM_DAYS_REQUEST, GET_PROGRAM_DAYS_SUCCESS, GET_PROGRAM_DAYS_FAILED, CREATE_PROGRAM_DAYS_REQUEST, CREATE_PROGRAM_DAYS_SUCCESS, CREATE_PROGRAM_DAYS_FAILED, UPDATE_PROGRAM_DAYS_REQUEST, DELETE_PROGRAM_DAYS_FAILED, DELETE_PROGRAM_DAYS_SUCCESS, DELETE_PROGRAM_DAYS_REQUEST, UPDATE_PROGRAM_DAYS_FAILED, UPDATE_PROGRAM_DAYS_SUCCESS, DELETE_PROGRAM_WEEKS_FAILED, DELETE_PROGRAM_WEEKS_SUCCESS, DELETE_PROGRAM_WEEKS_REQUEST, UPDATE_PROGRAM_WEEKS_FAILED, UPDATE_PROGRAM_WEEKS_SUCCESS, UPDATE_PROGRAM_WEEKS_REQUEST, CREATE_PROGRAM_WEEKS_FAILED, CREATE_PROGRAM_WEEKS_SUCCESS, CREATE_PROGRAM_WEEKS_REQUEST, GET_PROGRAM_WEEKS_FAILED, GET_PROGRAM_WEEKS_SUCCESS, GET_PROGRAM_WEEKS_REQUEST, GET_LIST_PROGRAM_WEEKS_FAILED, GET_LIST_PROGRAM_WEEKS_SUCCESS, GET_LIST_PROGRAM_WEEKS_REQUEST, UPDATE_PROGRAM_EXERCISE_SUCCESS, UPDATE_PROGRAM_EXERCISE_FAILED, CLEAR_PROGRAM_EXERCISE_REQUEST, CREATE_PROGRAM_REQUEST, CREATE_PROGRAM_SUCCESS, CREATE_PROGRAM_FAILED, GET_LIST_PROGRAM_REQUEST, GET_LIST_PROGRAM_SUCCESS, GET_LIST_PROGRAM_FAILED, UPDATE_PROGRAM_REQUEST, UPDATE_PROGRAM_SUCCESS, UPDATE_PROGRAM_FAILED, DELETE_PROGRAM_REQUEST, DELETE_PROGRAM_SUCCESS, DELETE_PROGRAM_FAILED, SELECTED_PROGRAM_ID, GET_SELECTED_PROGRAM_ID, CLEAR_WEEK_REQUEST, SELECTED_WEEK_LIST, CREATE_BLANK_WEEKS_REQUEST, CREATE_BLANK_WEEKS_SUCCESS, CREATE_BLANK_WEEKS_FAILED, } from "../Action/constant.js"

const initialState = {
    loading: false,
    success: false,
    GroupList: {},
    commonDetails: [],
    exerciseInfo: [],
    programExercise: [],
    singleBlockExercise: [],
    blockInfo: { loading: false, data: [] },
    groupInfo: { loading: false, data: [] },
    programWeekInfo: { loading: false, data: [] },
    programDayInfo: { loading: false, data: [] },
    isDeleteExercise: false,
    isExerciseUpdated: false,
    isCreatedExercise: false,
    isProgramExerciseUpdated: false,
    isCreatedProgramExercise: false,
    editBlockExercise: [],
    weekEditBlockExercise: [],
    programs: { loading: false, data: [] },
    programID: null,
    selectedWeekList: []
}

const programBuilder = (state = initialState, action) => {
    switch (action.type) {
        case POST_ACTIVITY_GROUP_DETAIL: {
            return {
                ...state,
                commonDetails: [...state.commonDetails, action.payload]
            }
        }
        case POST_ACTIVITY_DETAIL: {
            return {
                ...state,
                commonDetails: [...state.commonDetails, action.payload]
            }
        }
        case COMMON_ACTIVITY_DETAIL: {
            return {
                ...state,
                commonDetails: [...state.commonDetails, action.payload]
            }
        }
        case DELETE_COMMON_DETAILS: {
            const updateCommonData = state.commonDetails?.filter((d) => d.id !== action.payload);
            return {
                ...state,
                commonDetails: updateCommonData,
            }
        }
        case DELETE_EDITED_COMMON_DETAILS: {

            const editedCommonData = state.editBlockExercise?.filter((d) => d.id !== action.payload);
            return {
                ...state,
                editBlockExercise: editedCommonData,
            }
        }
        case DELETE_EDIT_WEEK_DATA:
            const weekUpdatedBlock = state.weekEditBlockExercise?.filter((d) => d.id !== action.payload)
            {
                return {
                    ...state,
                    success: true,
                    weekEditBlockExercise: weekUpdatedBlock
                }
            }

        case UPDATE_ACTIVTITY_DETAILS: {
            const tempActivity = [...state.commonDetails]
            const tempBlock = [...state.editBlockExercise]
            const tempWeekBlock = [...state.weekEditBlockExercise]

            const findActivityIndex = tempActivity.findIndex((data) => data.id === action.payload.id)
            tempActivity.splice(findActivityIndex, 1, action.payload);

            const findBlockIndex = tempBlock.findIndex((data) => data.id === action.payload.id)
            tempBlock.splice(findBlockIndex, 1, action.payload);

            const findWeekBlockIndex = tempWeekBlock.findIndex((data) => data.id === action.payload.id)
            tempWeekBlock.splice(findWeekBlockIndex, 1, action.payload);

            return {
                ...state,
                commonDetails: [...tempActivity],
                editBlockExercise: [...tempBlock],
                weekEditBlockExercise: [...tempWeekBlock]
            }
        }
        case DELETE_ACTIVITY_DETAILS: {
            const tempActivity1 = [...state.commonDetails]
            tempActivity1.splice(action.payload, 1)
            return {
                ...state,
                commonDetails: [...tempActivity1]
            }
        }

        case DELETE_ACTIVITY_GROUP: {
            const tempActivityGroup = [...state.commonDetails]
            tempActivityGroup.splice(action.payload, 1);
            return {
                ...state,
                commonDetails: [...tempActivityGroup]
            }
        }

        case RESET_ACTVITY_DETAILS_AND_ACTIVITY_GROUPS:
            {
                return {
                    ...state,
                    commonDetails: []
                }
            }
        case ADD_ACTIVTY_GROUP_ACTIVITTIES:
            {
                const tempActivityGroupData = [...state.commonDetails]
                tempActivityGroupData.splice(tempActivityGroupData.length - 1, 1, action.payload)
                return {
                    ...state,
                    commonDetails: [...tempActivityGroupData]
                }
            }

        case UPDATE_ACTIVITY_GROUP_DETAIL_ACTIVITY_DETAILS:
            {
                return {
                    ...state,
                    commonDetails: [...action.payload],
                }
            }
        case EDIT_UPDATE_ACTIVITY_GROUP_DETAIL_ACTIVITY_DETAILS:
            {
                return {
                    ...state,
                    editBlockExercise: [...action.payload],
                }
            }
        case WEEK_EDIT_UPDATE_ACTIVITY_GROUP_DETAIL_ACTIVITY_DETAILS:
            {
                return {
                    ...state,
                    weekEditBlockExercise: [...action.payload],
                }
            }
        case FETCH_EXCERSIZE_DATA:
            {
                return {
                    ...state,
                }
            }
        case DELETE_EXCERSIZE_DATA:
            let updatedExcersize = state.exerciseInfo?.filter(item => item.id !== action.payload)
            {
                return {
                    ...state,
                }
            }
        case FETCH_BLOCK_DATA:
            {
                return {
                    ...state,
                    blockInfo: { loading: false, data: [...state.blockInfo.data] }
                }
            }
        case FETCH_EDIT_BLOCK_DATA:
            {
                return {
                    ...state,
                    blockInfo: { loading: false, data: [...state.blockInfo.data] }
                }
            }
        case ADD_BLOCK_DATA:
            {
                return {
                    ...state,
                    blockInfo: { loading: false, data: [...action.payload] }
                }
            }
        case ADD_WEEK_DATA_SUCCESS: {
            return {
                ...state,
                GroupList: [...state.GroupList, action.payload]
            }
        }
        case EDIT_BLOCK_DATA:
            let editBlock = [];
            editBlock.push(action.payload);
            let EditBlock = state.blockInfo?.data.map(obj => editBlock?.find(o => o.id === obj.id) || obj);
            {
                return {
                    ...state,
                    success: true,
                    blockInfo: { loading: false, data: EditBlock },
                }
            }
        case WEEK_EDIT_BLOCK_DATA:
            let weekEditBlock = [];
            let WeekEditBlock = state.blockInfo?.data.map(obj => weekEditBlock?.find(w => w.id === obj.id) || obj);
            {
                return {
                    ...state,
                    success: true,
                    blockInfo: { loading: false, data: WeekEditBlock },
                }
            }
        case DELETE_BLOCK_DATA:
            let updatedBlock = state.blockInfo?.data.filter((d) => d.id !== action.payload)
            {
                return {
                    ...state,
                    blockInfo: { loading: false, data: updatedBlock }
                }
            }
        case FETCH_GROUP_DATA:
            {
                return {
                    ...state,
                    groupInfo: { loading: false, data: [...state.groupInfo.data] }
                }
            }
        case ADD_GROUP_DATA:
            {
                return {
                    ...state,
                    groupInfo: { loading: false, data: [...action.payload] }
                }
            }
        case DELETE_GROUP_DATA:
            let updatedGroup = state.groupInfo.data?.filter((d) => d.id !== action.payload)
            {
                return {
                    ...state,
                    groupInfo: { loading: false, data: updatedGroup }
                }
            }
        case FETCH_WEEK_GROUP_DATA:
            {
                return {
                    ...state,
                    GroupList: action.payload
                }
            }
        case EDIT_WEEK_DATA:
            {
                return {
                    ...state,
                    success: true,
                    GroupList: action.payload,
                }
            }
        case WEEK_EDIT_EXCERCIZE:
            {
                return {
                    ...state,
                    success: true,
                    weekEditBlockExercise: [...action.payload],
                }
            }
        case EDIT_EXCERSIZE_DATA:
            let editExcer = [];
            editExcer.push({ ...action.payload });
            let res = state.exerciseInfo?.map(obj => editExcer?.find(o => o.id === obj.id) || obj);
            {
                return {
                    ...state,
                    success: true,
                }
            }
        case EDIT_GROUP_DATA:
            let editGroup = [];
            editGroup.push(action.payload);
            let EditRes = state.groupInfo.data?.map(obj => editGroup?.find(o => o.id === obj.id) || obj);
            {
                return {
                    ...state,
                    success: true,
                    groupInfo: { loading: false, data: EditRes }
                }
            }
        case EDIT_BLOCK_EXCERSIZE_DATA:
            {
                return {
                    ...state,
                    success: true,
                    editBlockExercise: action.payload
                }
            }

        case CLEAR_EDIT_BLOCK_EXCERSIZE_DATA:
            {
                return {
                    ...state,
                    success: true,
                    editBlockExercise: []
                }
            }

        case WEEK_BLOCK_MODAL_DATA:
            {
                return {
                    ...state,
                    success: true,
                    weekEditBlockExercise: action.payload
                }
            }

        // <-------------------------------EXERCISE------------------------------->

        case CREATE_EXERCISE_REQUEST: {
            return {
                ...state,
                isCreatedExercise: true
            }
        }

        case CREATE_EXERCISE_SUCCESS: {
            const tempExerciseInfoObj = {
                id: action.payload.id,
                description: action.payload.description,
                video: action.payload.video,
                name: action.payload.name,
                tags: action.payload.tags
            }
            const tempExerciseInfo = state.exerciseInfo
            tempExerciseInfo.data.push(tempExerciseInfoObj)

            return {
                ...state,
                exerciseInfo: tempExerciseInfo,
                isCreatedExercise: false
            }
        }

        case CREATE_EXERCISE_FAILED: {
            return {
                ...state,
                isCreatedExercise: false
            }
        }

        case GET_LIST_EXERCISE_REQUEST: {
            return {
                ...state,
                loading: true,
            }
        }

        case GET_LIST_EXERCISE_SUCCESS: {
            return {
                ...state,
                loading: false,
                exerciseInfo: action.data
            }
        }

        case GET_LIST_EXERCISE_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_EXERCISE_REQUEST: {
            return {
                ...state,
            }
        }

        case GET_EXERCISE_SUCCESS: {
            return {
                ...state,
            }
        }

        case GET_EXERCISE_FAILED: {
            return {
                ...state,
            }
        }

        case UPDATE_EXCERSIZE_DATA_REQUEST: {
            return {
                ...state,
                isExerciseUpdated: true
            }
        }

        case UPDATE_EXCERSIZE_DATA_SUCCESS: {

            const tempExerciseInfo = state.exerciseInfo
            const findExerciseIndex = tempExerciseInfo.data.findIndex((data) => data.id === action.data.id)
            tempExerciseInfo.data.splice(findExerciseIndex, 1, action.data);
            return {
                ...state,
                exerciseInfo: [...tempExerciseInfo],
                isExerciseUpdated: false
            }
        }

        case UPDATE_EXCERSIZE_DATA_FAILED: {
            return {
                ...state, isExerciseUpdated: false

            }
        }

        case DELETE_EXCERSIZE_DATA_REQUEST: {
            return {
                ...state,
                isDeleteExercise: true
            }
        }

        case DELETE_EXCERSIZE_DATA_SUCCESS: {
            const tempExerciseInfo = state.exerciseInfo
            const findExerciseIndex = tempExerciseInfo.data.findIndex((data) => data.id === action.payload.payload)
            tempExerciseInfo.data.splice(findExerciseIndex, 1);
            return {
                ...state,
                loading: false,
                exerciseInfo: [...tempExerciseInfo],
                isDeleteExercise: false
            }
        }

        case DELETE_EXCERSIZE_DATA_FAILED: {
            return {
                ...state,
                isDeleteExercise: false
            }
        }

        // <-------------------------------PROGRAM EXERCISE------------------------------->

        case GET_LIST_PROGRAM_EXERCISE_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }

        case GET_LIST_PROGRAM_EXERCISE_SUCCESS: {
            return {
                ...state,
                loading: false,
                programExercise: [...action.payload]
            }
        }

        case GET_LIST_PROGRAM_EXERCISE_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_PROGRAM_EXERCISE_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }

        case GET_PROGRAM_EXERCISE_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_PROGRAM_EXERCISE_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        case CREATE_PROGRAM_EXERCISE_REQUEST: {
            return {
                ...state,
                isCreatedProgramExercise: true
            }
        }

        case CREATE_PROGRAM_EXERCISE_SUCCESS: {
            const tempSingleProgramExercise = [...state.singleBlockExercise]
            const tempProgramExercise = [...state.programExercise]
            tempProgramExercise.push(action.payload)
            tempSingleProgramExercise.push(action.payload)
            const tempProgDayInfo = [...state.programDayInfo.data]
            if (action.payload.programDay > 0) {
                const findProgDayIndex = tempProgDayInfo.findIndex((data) => data.id === action.payload.programDay)
                const program_day = tempProgDayInfo[findProgDayIndex]
                const findGroupIndex = program_day.groups.findIndex((data) => data.group_pk === action.payload.group)
                const group = program_day.groups[findGroupIndex].group
                const findBlockIndex = group.blocks.findIndex((data) => data.id === action.payload.blockId)
                const block = program_day.groups[findGroupIndex].group.blocks[findBlockIndex]
                program_day.groups[findGroupIndex].group.blocks[findBlockIndex].exercises.push(action.payload)
                tempProgDayInfo.splice(findProgDayIndex, 1, program_day);
            }
            return {
                ...state,
                programExercise: [...tempProgramExercise],
                singleBlockExercise: [...tempSingleProgramExercise],
                isCreatedProgramExercise: false,
                programDayInfo: { loading: false, data: [...tempProgDayInfo] },
            }
        }

        case CREATE_PROGRAM_EXERCISE_FAILED: {
            return {
                ...state,
                isCreatedProgramExercise: false
            }
        }

        case UPDATE_PROGRAM_EXERCISE_REQUEST: {
            return {
                ...state,
                isProgramExerciseUpdated: true
            }
        }

        case UPDATE_PROGRAM_EXERCISE_SUCCESS: {
            const tempProgExerciseInfo = [...state.programExercise]
            const findProgExerciseIndex = tempProgExerciseInfo.findIndex((data) => data.id === action.payload.id)
            tempProgExerciseInfo.splice(findProgExerciseIndex, 1, action.payload);
            const tempProgDayInfo = [...state.programDayInfo.data]
            const tempBlockInfo = [...state.blockInfo.data]
            if (action.payload.programDay > 0) {
                const findProgDayIndex = tempProgDayInfo.findIndex((data) => data.id === action.payload.programDay)
                const program_day = tempProgDayInfo[findProgDayIndex]
                const findGroupIndex = program_day.groups.findIndex((data) => data.group_pk === action.payload.group)
                const group = program_day.groups[findGroupIndex].group
                const findBlockIndex = group.blocks.findIndex((data) => data.id === action.payload.blockId)
                const block = program_day.groups[findGroupIndex].group.blocks[findBlockIndex]
                const findProgExerciseIndex = block.exercises.findIndex((data) => data.id === action.payload.id)
                program_day.groups[findGroupIndex].group.blocks[findBlockIndex].exercises[findProgExerciseIndex] = action.payload
                tempProgDayInfo.splice(findProgDayIndex, 1, program_day);
            }
            if (action.payload.source === "sidebar") {
                const findBlockIndex = tempBlockInfo.findIndex((data) => data.id === action.payload.blockId)
                const findProgramExerciseIndexInBlock = tempBlockInfo[findBlockIndex].exercises.findIndex((data) => data.id === action.payload.id)
                tempBlockInfo[findBlockIndex].exercises.splice(findProgramExerciseIndexInBlock, 1, action.payload);
            }
            return {
                ...state,
                loading: false,
                programExercise: [...tempProgExerciseInfo],
                isProgramExerciseUpdated: false,
                programDayInfo: { loading: false, data: [...tempProgDayInfo] },
                blockInfo: { loading: false, data: [...tempBlockInfo] },
            }
        }

        case UPDATE_PROGRAM_EXERCISE_FAILED: {
            return {
                ...state,
                isProgramExerciseUpdated: false
            }
        }

        case DELETE_PROGRAM_EXERCISE_REQUEST: {
            return {
                ...state,
                loading: false
            }
        }

        case DELETE_PROGRAM_EXERCISE_SUCCESS: {
            const tempProgExersizeId = action.payload.payload
            let tempProgExercise = state.programExercise?.filter(item => item.id !== tempProgExersizeId)
            return {
                ...state,
                loading: false,
                programExercise: [...tempProgExercise]
            }
        }

        case DELETE_PROGRAM_EXERCISE_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        // <-------------------------------BLOCKS------------------------------->

        case GET_LIST_BLOCKS_REQUEST: {
            return {
                ...state,
                blockInfo: { loading: true, data: [...state.blockInfo.data] }
            }
        }

        case GET_LIST_BLOCKS_SUCCESS: {
            return {
                ...state,
                blockInfo: { loading: false, data: [...action.payload] }
            }
        }

        case GET_LIST_BLOCKS_FAILED: {
            return {
                ...state,
                blockInfo: { loading: false, data: [] }
            }
        }


        case GET_BLOCK_REQUEST: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_BLOCK_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_BLOCK_FAILED: {
            return {
                ...state,
                loading: false
            }
        }


        case CREATE_BLOCKS_REQUEST: {
            return {
                ...state,
                blockInfo: { loading: true, data: [...state.blockInfo.data] }
            }
        }

        case CREATE_BLOCKS_SUCCESS: {
            const tempBlock = [...state.blockInfo.data]
            tempBlock.push(action.payload)
            return {
                ...state,
                blockInfo: { loading: false, data: [...tempBlock] }
            }
        }

        case CREATE_BLOCKS_FAILED: {
            return {
                ...state,
                blockInfo: { loading: false, data: [] }
            }
        }

        case UPDATE_BLOCKS_REQUEST: {
            return {
                ...state,
                blockInfo: { loading: true, data: [...state.blockInfo.data] }
            }
        }

        case UPDATE_BLOCKS_SUCCESS: {
            const tempBlockInfo = [...state.blockInfo.data]
            const findBlockIndex = tempBlockInfo.findIndex((data) => data.id === action.payload.id)
            tempBlockInfo.splice(findBlockIndex, 1, action.payload);
            const tempProgDayInfo = [...state.programDayInfo.data]
            if (action.payload.programDay > 0) {
                const findProgDayIndex = tempProgDayInfo.findIndex((data) => data.id === action.payload.programDay)
                const program_day = tempProgDayInfo[findProgDayIndex]
                const findGroupIndex = program_day.groups.findIndex((data) => data.group_pk === action.payload.group)
                const group = program_day.groups[findGroupIndex].group
                const findBlockIndex = group.blocks.findIndex((data) => data.id === action.payload.id)
                program_day.groups[findGroupIndex].group.blocks[findBlockIndex] = action.payload
                tempProgDayInfo.splice(findProgDayIndex, 1, program_day);
            }
            return {
                ...state,
                blockInfo: { loading: false, data: [...tempBlockInfo] },
                programDayInfo: { loading: false, data: [...tempProgDayInfo] },
                singleBlockExercise: [],
            }
        }

        case UPDATE_BLOCKS_FAILED: {
            return {
                ...state,
                blockInfo: { loading: false, data: [] }
            }
        }


        case DELETE_BLOCKS_REQUEST: {
            return {
                ...state,
                loading: false
            }
        }

        case DELETE_BLOCKS_SUCCESS: {
            const tempBlockId = action.payload.payload
            let tempBlock = state.blockInfo?.data?.filter(item => item.id !== tempBlockId)
            return {
                ...state,
                blockInfo: { loading: false, data: [...tempBlock] },
            }
        }

        case DELETE_BLOCKS_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        // <-------------------------------GROUPS------------------------------->

        case GET_LIST_GROUPS_REQUEST: {
            return {
                ...state,
                groupInfo: { loading: true, data: [...state.groupInfo.data] }
            }
        }

        case GET_LIST_GROUPS_SUCCESS: {
            return {
                ...state,
                groupInfo: { loading: false, data: [...action.payload] }
            }
        }

        case GET_LIST_GROUPS_FAILED: {
            return {
                ...state,
                groupInfo: { loading: false, data: [] }
            }
        }

        case GET_GROUPS_REQUEST: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_GROUPS_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_GROUPS_FAILED: {
            return {
                ...state,
                loading: false
            }
        }


        case CREATE_GROUPS_REQUEST: {
            return {
                ...state,
                groupInfo: { loading: true, data: [...state.groupInfo.data] }
            }
        }

        case CREATE_GROUPS_SUCCESS: {
            const tempGroup = [...state.groupInfo.data]
            tempGroup.push(action.payload)
            return {
                ...state,
                groupInfo: { loading: false, data: [...tempGroup] }
            }
        }

        case CREATE_GROUPS_FAILED: {
            return {
                ...state,
                groupInfo: { loading: false, data: [] }
            }
        }


        case UPDATE_GROUPS_REQUEST: {
            return {
                ...state,
                groupInfo: { loading: true, data: [...state.groupInfo.data]  }
            }
        }

        case UPDATE_GROUPS_SUCCESS: {
            const tempGroupInfo = [...state.groupInfo.data]
            const findGroupIndex = tempGroupInfo.findIndex((data) => data.id === action.payload.id)
            tempGroupInfo.splice(findGroupIndex, 1, action.payload);
            const tempProgDayInfo = [...state.programDayInfo.data]
            if (action.payload.programDay > 0) {
                const findProgDayIndex = tempProgDayInfo.findIndex((data) => data.id === action.payload.programDay)
                const program_day = tempProgDayInfo[findProgDayIndex]
                const findGroupIndex2 = program_day.groups.findIndex((data) => data.group_pk === action.payload.id)
                action.payload.blocks = action.payload.blocks.map((block) => (block.block))
                action.payload.blocks.forEach( (block, index) => {
                    var sorted = block.exercises.sort((a, b) => {
                      if (a.position < b.position) {
                        return -1;
                      }
                    })
                    action.payload.blocks[index].exercises = sorted
                })
                program_day.groups[findGroupIndex2].group = action.payload
                tempProgDayInfo.splice(findProgDayIndex, 1, program_day);
            }
            return {
                ...state,
                groupInfo: { loading: false, data: [...tempGroupInfo] },
                programDayInfo: { loading: false, data: [...tempProgDayInfo] }
            }
        }

        case UPDATE_GROUPS_FAILED: {
            const tempGroupInfo = [...state.groupInfo.data]
            return {
                ...state,
                groupInfo: { loading: false, data: [...tempGroupInfo] }
            }
        }


        case DELETE_GROUPS_REQUEST: {
            return {
                ...state,
                loading: false
            }
        }

        case DELETE_GROUPS_SUCCESS: {
            const tempGroupId = action.payload.payload
            let tempGroup = state.groupInfo?.data?.filter(item => item.id !== tempGroupId)
            return {
                ...state,
                groupInfo: { loading: false, data: [...tempGroup] }
            }
        }

        case DELETE_GROUPS_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        // <--------------------------------PROGRAMS---------------------------------->

        case GET_LIST_PROGRAM_REQUEST: {
            return {
                ...state,
                programs: { loading: true, data: [...state.programs.data] }
            }
        }

        case GET_LIST_PROGRAM_SUCCESS: {
            return {
                ...state,
                programs: { loading: false, data: [...action.payload] }
            }
        }

        case GET_LIST_PROGRAM_FAILED: {
            return {
                ...state,
                programs: { loading: 'error', data: [...state.programs.data] }
            }
        }

        case CREATE_PROGRAM_REQUEST: {
            return {
                ...state,
                programs: { loading: true, data: [...state.programs.data] }
            }
        }

        case CREATE_PROGRAM_SUCCESS: {
            const tempProgram = [...state.programs.data]
            tempProgram.push(action.payload)
            return {
                ...state,
                programs: { loading: false, data: [...tempProgram], created: action.payload}
            }
        }

        case CREATE_PROGRAM_FAILED: {
            return {
                ...state,
                programs: { loading: false, data: [] }
            }
        }

        case UPDATE_PROGRAM_REQUEST: {
            return {
                ...state,
                programs: { loading: true, data: [...state.programs.data] }
            }
        }

        case UPDATE_PROGRAM_SUCCESS: {
            const tempProgInfo = [...state.programs.data]
            const findProgIndex = tempProgInfo.findIndex((data) => data.id === action.payload.id)
            tempProgInfo.splice(findProgIndex, 1, action.payload);
            return {
                ...state,
                programs: { loading: false, data: [...tempProgInfo] }
            }
        }

        case UPDATE_PROGRAM_FAILED: {
            return {
                ...state,
                programs: { loading: false, data: [] }
            }
        }


        case DELETE_PROGRAM_REQUEST: {
            return {
                ...state,
                loading: false
            }
        }

        case DELETE_PROGRAM_SUCCESS: {
            const tempProgId = action.payload.payload
            let tempProg = state.programs?.data?.filter(item => item.id !== tempProgId)
            return {
                ...state,
                programs: { loading: false, data: [...tempProg] }
            }
        }

        case DELETE_PROGRAM_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        // <-------------------------------PROGRAM DAYS------------------------------->

        case GET_LIST_PROGRAM_DAYS_REQUEST: {
            const tempProgramDay = [...state.programDayInfo.data]
            return {
                ...state,
                programDayInfo: { loading: true, data: [...tempProgramDay] }
            }
        }

        case GET_LIST_PROGRAM_DAYS_SUCCESS: {
            return {
                ...state,
                programDayInfo: { loading: false, data: [...action.payload] }
            }
        }

        case GET_LIST_PROGRAM_DAYS_FAILED: {
            return {
                ...state,
                programDayInfo: { loading: false, data: [] }
            }
        }

        case GET_PROGRAM_DAYS_REQUEST: {
            return {
                ...state,
                loading: true,
            }
        }

        case GET_PROGRAM_DAYS_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_PROGRAM_DAYS_FAILED: {
            return {
                ...state,
                loading: false
            }
        }


        case CREATE_PROGRAM_DAYS_REQUEST: {
        const tempProgramDay = [...state.programDayInfo.data]
            return {
                ...state,
                programDayInfo: { loading: true, data: [...tempProgramDay] }
            }
        }

        case CREATE_PROGRAM_DAYS_SUCCESS: {
            const tempProgramDay = [...state.programDayInfo.data]
            tempProgramDay.push(action.payload)
            return {
                ...state,
                programDayInfo: { loading: false, data: [...tempProgramDay] }
            }
        }

        case CREATE_PROGRAM_DAYS_FAILED: {
            return {
                ...state,
                programDayInfo: { loading: false, data: [] }
            }
        }


        case UPDATE_PROGRAM_DAYS_REQUEST: {
            const tempProgramDay = [...state.programDayInfo.data]
            return {
                ...state,
                programDayInfo: { loading: true, data: [...tempProgramDay] }
            }
        }

        case UPDATE_PROGRAM_DAYS_SUCCESS: {
            const tempProgDayInfo = [...state.programDayInfo.data]
            const findProgDayIndex = tempProgDayInfo.findIndex((data) => data.id === action.payload.id)
            tempProgDayInfo.splice(findProgDayIndex, 1, action.payload);
            return {
                ...state,
                programDayInfo: { loading: false, data: [...tempProgDayInfo] }
            }
        }

        case UPDATE_PROGRAM_DAYS_FAILED: {
            return {
                ...state,
                programDayInfo: { loading: false, data: [] }
            }
        }


        case DELETE_PROGRAM_DAYS_REQUEST: {
            return {
                ...state,
                loading: false
            }
        }

        case DELETE_PROGRAM_DAYS_SUCCESS: {
            const tempProgDayId = action.payload.payload
            let tempProgDay = state.programDayInfo?.data?.filter(item => item.id !== tempProgDayId)
            return {
                ...state,
                programDayInfo: { loading: false, data: [...tempProgDay] }
            }
        }

        case DELETE_PROGRAM_DAYS_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        // <-------------------------------PROGRAM WEEKS------------------------------->

        case GET_LIST_PROGRAM_WEEKS_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }

        case GET_LIST_PROGRAM_WEEKS_SUCCESS: {
            return {
                ...state,
                programWeekInfo: { loading: false, data: [...action.payload] }
            }
        }

        case GET_LIST_PROGRAM_WEEKS_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_PROGRAM_WEEKS_REQUEST: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_PROGRAM_WEEKS_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }

        case GET_PROGRAM_WEEKS_FAILED: {
            return {
                ...state,
                loading: false
            }
        }


        case CREATE_PROGRAM_WEEKS_REQUEST: {
            return {
                ...state,
                programWeekInfo: { loading: true, data: [] }
            }
        }

        case CREATE_PROGRAM_WEEKS_SUCCESS: {
            const tempProg = [...state.programWeekInfo.data]
            tempProg.push(action.payload)
            return {
                ...state,
                programWeekInfo: { loading: false, data: [...tempProg] }
            }
        }

        case CREATE_PROGRAM_WEEKS_FAILED: {
            return {
                ...state,
                programWeekInfo: { loading: false, data: [] }
            }
        }

        case CREATE_BLANK_WEEKS_REQUEST: {
            return {
                ...state,
                programWeekInfo: { loading: true, data: [...state.programWeekInfo.data] }
            }
        }

        case CREATE_BLANK_WEEKS_SUCCESS: {
             const tempProg = [...state.programWeekInfo.data]
//            const tempProg = []
//            const Id= programWeekInfo.data.length>0 ? programWeekInfo?.data.slice(-1)[0].program : null;
//            const program= state.programs.data.length > 0 ? (state.programID!==null ? state.programID : Id ) : null
//            const tempData=[]
//            for (var i = state.programWeekInfo.data.length - 1; i >= 0; i--) {
//                if (state.programWeekInfo.data[i].program === program){
//                    tempData.push(...state.programWeekInfo.data.splice(i, 1));
//                }
//            }
             tempProg.push(action.payload)

            return {
                ...state,
                selectedWeekList: [],
                programWeekInfo: { loading: false, data: [...tempProg] }
            }
        }

        case CREATE_BLANK_WEEKS_FAILED: {
            return {
                ...state,
                programWeekInfo: { loading: false, data: [] }
            }
        }


        case UPDATE_PROGRAM_WEEKS_REQUEST: {
            return {
                ...state,
                programWeekInfo: { loading: true, data: [] }
            }
        }

        case UPDATE_PROGRAM_WEEKS_SUCCESS: {
            const tempProgWeekInfo = [...state.programWeekInfo.data]
            const findProgWeekIndex = tempProgWeekInfo.findIndex((data) => data.id === action.data.id)
            tempProgWeekInfo.splice(findProgWeekIndex, 1, action.data);
            return {
                ...state,
                programWeekInfo: { loading: false, data: [...tempProgWeekInfo] }
            }
        }

        case UPDATE_PROGRAM_WEEKS_FAILED: {
            return {
                ...state,
                programWeekInfo: { loading: false, data: [] }
            }
        }


        case DELETE_PROGRAM_WEEKS_REQUEST: {
            return {
                ...state,
                loading: false
            }
        }

        case DELETE_PROGRAM_WEEKS_SUCCESS: {
            const tempProgWeekId = action.payload.payload
            let tempProgWeek = state.programWeekInfo?.data?.filter(item => item.id !== tempProgWeekId)
            return {
                ...state,
                programWeekInfo: { loading: false, data: [...tempProgWeek] }
            }
        }

        case DELETE_PROGRAM_WEEKS_FAILED: {
            return {
                ...state,
                loading: false
            }
        }

        case CLEAR_PROGRAM_EXERCISE_REQUEST: {
            return {
                ...state,
                loading: false,
                singleBlockExercise: []
            }
        }
        case SELECTED_PROGRAM_ID: {
            return {
                ...state,
                loading: false,
                programID: action.payload
            }
        }

        case CLEAR_WEEK_REQUEST: {
            return {
                ...state,
                loading:false,
                selectedWeekList: []
            }
        }

        case SELECTED_WEEK_LIST: {
            return {
                ...state,
                selectedWeekList: action.payload
            }
        }

        default:
            return state;
    }
}
export default programBuilder
